module.exports = __webpack_public_path__ + "static/media/safetyInfoEN.7565f782.pdf";